import requestManager from "../platformApi/requestManager";

import appHelper from "@util/appHelper";
import axios from "@util/axios";

export default {

    getBizCouponList(bizId, callback) {
        requestManager.request({
            url : 'portal/v2/coupon/getBizCouponList',
            data : {
                bizId : bizId
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        })
    },

    receiveCoupon(id, callback) {
        requestManager.request({
            url : 'portal/v2/coupon/receive/batch',
            method : 'post',
            data : {
                batchId : id
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback();
        })

    },

    receiveCouponFromGroup : function(data) {
        return axios({
            url: 'api/v1/common/coupon/receive/group',
            method : 'post',
            data: data
        });
    }

}
